import React from 'react'
import * as Styles from '../style';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import HookPayPoints from '../../hooks';
import UseGetData from '../../../../../HookAxios/getdata';
import { GET_REQUEST } from '../../../../../HooksApi/useApi';
const PayMethod = () => {
    const { valueMethod, ChangeValueMethod, LoadingPaymentsMethod, dataPaymentsMethod } = HookPayPoints()

    return (
        <>
            {
                !LoadingPaymentsMethod && dataPaymentsMethod ?
                    <Styles.Section>
                        <FormControl style={{ width: '100%' }}>
                            <Styles.TextHeader variant='h3' >
                                الدفع
                            </Styles.TextHeader>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name={`controlled-radio-buttons-group`}
                                value={valueMethod}
                                onChange={ChangeValueMethod}

                            >
                                {
                                    dataPaymentsMethod?.data?.data?.payments.map((el, i) =>
                                        <Styles.ContentMethod key={i}>
                                            <FormControlLabel value={JSON.stringify(el)}
                                                control={<Radio />} label={
                                                    <img
                                                        style={{ height: '30px' }}
                                                        src={`${process.env.REACT_APP_BASE_URL}${el.image_path}`} alt={el.name} />
                                                } />
                                            {el.name}
                                        </Styles.ContentMethod>
                                    )

                                }
                            </RadioGroup>
                        </FormControl>
                    </Styles.Section> : 'null'
            }
        </>

    )
}

export default PayMethod